<template>
  <div id="group">
    <group-component></group-component>
  </div>
</template>

<script>
import GroupComponent from "@/components/GroupComponent";

export default {
  components: {
    GroupComponent,
  },
};
</script>
